const parse = (text) => {

    return {
        input: text,

        parsed: function () {
            return this.input.trim()
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            return []
        },

        value: function () {
            return String(this.input)
        },

        format: function () {
            return String(this.parsed())
        },
    }
}

export default {
    parse,
}